import { RcFile } from 'antd/es/upload';
import { addMonths, formatISO } from 'date-fns';
import api from '../../../app/api';
import { getBase64, getFileDigest, spliceBase64 } from '../../../shared/utils/file-handling/file-handling';
import { SignRequestDocumentMetadata } from '../../sign-requests/models/sign-request-document-metadata';
import { ArchiveFile } from '../models/archive-file';
import { FetchBaseQueryError, FetchBaseQueryMeta, QueryReturnValue } from '@reduxjs/toolkit/query';

export const customersApi = api
  .enhanceEndpoints({
    addTagTypes: ['Metadata', 'FileUpload'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      uploadArchiveFiles: builder.mutation<ArchiveFile, { file: RcFile; requestId?: string }>({
        async queryFn(upload, _queryApi, _extraOptions, baseQuery) {
          return getBase64(upload.file).then(async data => {
            const base64Result = spliceBase64(data);
            const digest = await getFileDigest(upload.file);

            return baseQuery({
              url: '/portal-api/v1/archive/files',
              method: 'POST',
              body: {
                ...(upload.requestId && { request: upload.requestId }),
                name: upload.file.name,
                content: base64Result,
                mimeType: upload.file.type,
                digest,
                expiresAt: formatISO(addMonths(new Date(), 1)),
              },
            }) as QueryReturnValue<ArchiveFile, FetchBaseQueryError, FetchBaseQueryMeta>;
          });
        },
        invalidatesTags: ['FileUpload'],
      }),
      getSignRequestDocumentMetadata: builder.query<SignRequestDocumentMetadata[], string>({
        query: id => ({
          url: `/portal-api/v1/archive/documents/${id}/metadata`,
        }),
        providesTags: ['Metadata'],
      }),
      updateMetadata: builder.mutation<SignRequestDocumentMetadata, { name: string; value: string; id: string }>({
        query: ({ id, ...body }) => ({
          url: `/portal-api/v1/archive/documents/${id}/metadata`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Metadata'],
      }),
    }),
    overrideExisting: false,
  });

export const { useUploadArchiveFilesMutation, useGetSignRequestDocumentMetadataQuery, useUpdateMetadataMutation } =
  customersApi;
